/**
 * Author:hong.rong
 * Desc:容器组件
 * Date:2022-08-09
 */

import * as React from 'react'
import { Layout } from 'antd'
import classNames from 'classnames'
import { observer, useLocalObservable } from 'mobx-react-lite'
import type { NextRouter } from 'next/router'
import dynamic from 'next/dynamic'
import globalStore from '@/globalStore'
import DataGuide from '@/page-components/data/push/guide'
// import WorksGuide from '@/page-components/works/Guide'
// import useSafePush from '@/layouts/components/Header/useSafePush'
import { getLoginStatus } from '@/utils'
import SidebarLayout from './SidebarLayout'
import InspirationLayout from './InspirationLayout'
import {
  MEDIA_SIDER_MENUS,
  MEDIA_ROUTE_MAP,
  DATA_SIDER_MENUS,
  DATA_ROUTE_MAP,
  WALLET_ROUTE_MAP,
  WALLET_SIDER_MENUS,
  MANAGEMENT_ROUTE_MAP,
  MANAGEMENT_SIDER_MENUS,
} from './constant'
import styles from './index.module.less'

const { Content } = Layout

type MainType = {
  giveawayChannel: any
  router: NextRouter
  children: any
}

const WorksGuide = dynamic(() => import('@/page-components/works/Guide'))

const Main = ({ giveawayChannel, router, children }: MainType) => {
  const globalMobx = useLocalObservable(() => globalStore)
  const userInfo = globalMobx?.userInfo || {}
  // 是否个人
  const isPersonal = globalMobx?.getIsPersonal?.()
  const pathname = router.pathname
  // const { safePush } = useSafePush()

  const menus = React.useMemo(() => {
    if (MEDIA_ROUTE_MAP.includes(pathname) && pathname !== '/media/creative') {
      return MEDIA_SIDER_MENUS
    }
    if (DATA_ROUTE_MAP.includes(pathname)) {
      return DATA_SIDER_MENUS
    }
    if (WALLET_ROUTE_MAP.includes(pathname)) {
      return WALLET_SIDER_MENUS
    }
    if (MANAGEMENT_ROUTE_MAP.includes(pathname)) {
      return MANAGEMENT_SIDER_MENUS
    }
  }, [pathname])

  /**
   * 切换路由
   * @param path
   */
  const onRouteChange = async (path: string) => {
    if (!path || path === pathname) return
    const currentPath = router.query?.from === 'data' ? `${path}?from=data` : path
    // safePush(currentPath)
    await router.push(currentPath)
  }

  // 数据中心引导页逻辑
  if (['/data/analyse', '/data/push', '/data/diagnosis'].includes(pathname) && !userInfo?.token) {
    return (
      <Content className={classNames(styles.content)}>
        <DataGuide />
      </Content>
    )
  }

  /**
   * 在不展示引导页时，则展示带左侧菜单的页面
   */
  if (
    (MEDIA_ROUTE_MAP.includes(pathname) && pathname !== '/media/creative') ||
    DATA_ROUTE_MAP.includes(pathname) ||
    WALLET_ROUTE_MAP.includes(pathname) ||
    MANAGEMENT_ROUTE_MAP.includes(pathname)
  ) {
    return (
      <SidebarLayout menus={menus} pathname={pathname} onChange={onRouteChange}>
        <Content className={classNames(styles.content)}>{children}</Content>
      </SidebarLayout>
    )
  }

  // 作品库引导页
  if (['/works'].includes(pathname)) {
    // console.log(userInfo, 'userInfo')
    if (!userInfo?.token) {
      return <WorksGuide />
    }
    if (Object.keys(userInfo || {}).length === 0) {
      return null
    }
  }

  /**
   * 去收藏
   */
  const onCollect = () => {
    if (!getLoginStatus()) {
      globalMobx.loginModalToggle(true, () => (globalMobx.targetPathUrl = '/collect?tab=0'))
    } else {
      router.push('/collect?tab=0')
    }
  }

  // 创意灵感
  if (pathname.includes('/inspiration')) {
    return (
      <InspirationLayout
        giveawayChannel={giveawayChannel}
        query={router?.query || {}}
        pathname={pathname}
        isPersonal={isPersonal}
        userInfo={userInfo}
        memberReceiveShow={globalMobx.memberReceiveShow}
        onCollect={onCollect}
        onChange={onRouteChange}
      >
        {children}
      </InspirationLayout>
    )
  }

  return <Content className={classNames(styles.content)}>{children}</Content>
}
export default observer(Main)
